import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=eeabf4fa&scoped=true&"
import script from "./ClienteForm.vue?vue&type=script&lang=js&"
export * from "./ClienteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeabf4fa",
  null
  
)

export default component.exports